import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installContactTracking, loadTagManager } from './analytics/contactTracking';

installContactTracking();
loadTagManager('GTM-KJ6S9QFN');

const container = document.getElementById('root');
const app = <React.StrictMode><App path={window.location.pathname} /></React.StrictMode>;
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
